// import { toast } from "react-hot-toast";
import ActionCreator from "../../utils/helpers/actionCreator";
import { ManagerService } from "../../utils/services/manager.service";
import * as ManagerConstants from "../constants/manager.constant";
import { expiredTokenCheck } from "./auth.action";

export const getRoutablePaycenters = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(ManagerConstants.ROUTE_PAYCENTER_REQUEST));
    const { data: responseData } =
      await ManagerService.listRoutablePaycenters();
    // if (responseData.status === "FAILED") throw responseData;
    dispatch(
      ActionCreator(ManagerConstants.ROUTE_PAYCENTER_SUCCESS, responseData)
    );
    // toast.success("Routable paycenters fetched successfully.");
  } catch (error) {
    expiredTokenCheck(error, dispatch);
    dispatch(ActionCreator(ManagerConstants.ROUTE_PAYCENTER_FAILURE));
  }
};

export const getRoutingConfig = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(ManagerConstants.ROUTING_CONFIG_REQUEST));
    const { data: responseData } = await ManagerService.listRoutingConfig();
    // if (responseData.status === "FAILED") throw responseData;
    dispatch(
      ActionCreator(ManagerConstants.ROUTING_CONFIG_SUCCESS, responseData)
    );
    // toast.success("Routes fetched successfully.");
  } catch (error) {
    expiredTokenCheck(error, dispatch);
    dispatch(ActionCreator(ManagerConstants.ROUTING_CONFIG_FAILURE));
  }
};

export const getMobileDomainBrandIdentity = () => async (dispatch) => {
  try {
    dispatch(
      ActionCreator(ManagerConstants.GET_MOBILE_DOMAIN_BRAND_IDENTITY_REQUEST)
    );
    const { data: responseData } =
      await ManagerService.fetchMobileDomainBrandIdentity();
    if (responseData.status === "FAILED") throw responseData;
    const domainData = responseData["data"];

    dispatch(
      ActionCreator(
        ManagerConstants.GET_MOBILE_DOMAIN_BRAND_IDENTITY_SUCCESS,
        domainData
      )
    );
  } catch (error) {
    dispatch(
      ActionCreator(ManagerConstants.GET_MOBILE_DOMAIN_BRAND_IDENTITY_FAILURE)
    );
  }
};

export const getApiTypes = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(ManagerConstants.LIST_API_TYPES_REQUEST));
    const { data: responseData } = await ManagerService.listApiTypes();
    if (responseData.status === "FAILED") throw responseData;
    const domainData = responseData["data"];

    dispatch(
      ActionCreator(ManagerConstants.LIST_API_TYPES_SUCCESS, domainData)
    );
  } catch (error) {
    dispatch(ActionCreator(ManagerConstants.LIST_API_TYPES_FAILURE));
  }
};

export const getApiIntegrationsList = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(ManagerConstants.LIST_API_INTEGRATIONS_REQUEST));
    const { data: responseData } = await ManagerService.listApiIntegrations();
    if (responseData.status === "FAILED") throw responseData;
    const domainData = responseData["data"];

    dispatch(
      ActionCreator(ManagerConstants.LIST_API_INTEGRATIONS_SUCCESS, domainData)
    );
  } catch (error) {
    dispatch(ActionCreator(ManagerConstants.LIST_API_INTEGRATIONS_FAILURE));
  }
};

export const getHideViewValues = () => async (dispatch) => {
  try {
    dispatch(ActionCreator(ManagerConstants.LIST_HIDE_VIEW_REQUEST));
    const { data: responseData } = await ManagerService.getHideViewValues();
    if (responseData.status === "FAILED") throw responseData;
    const domainData = responseData["data"];

    dispatch(
      ActionCreator(ManagerConstants.LIST_HIDE_VIEW_SUCCESS, domainData)
    );
  } catch (error) {
    dispatch(ActionCreator(ManagerConstants.LIST_HIDE_VIEW_FAILURE));
  }
};
